import { ApiProvider, createQueryClient } from '@fidalia/api';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { apiClient, tokenStore } from '@/lib/api';
import { routeTree } from './routeTree.gen';
import './styles.css';

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient, tokens: tokenStore, api: apiClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root introuvable');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={apiClient}>
        <RouterProvider router={router} />
      </ApiProvider>
    </QueryClientProvider>
  </StrictMode>,
);
